import React from 'react';
import Button from '../../../generic-components/Button';
import { PlaidLink } from './PlaidLink';
import { IPostLinkData } from '../../../types';

interface IProps {
  linkToken: string;
  isLoading: boolean;
  isFetchLinkToken: boolean;
  callbackHandler: () => void;
  handlePostLink: (data: IPostLinkData) => void;
  linkStyle: string;
  linkTitle: string;
  shouldInvertLoaderColor?: boolean;
  shouldAutoOpenLink: boolean;
}

export const PlaidActionWrapper = ({
  linkToken,
  callbackHandler,
  isLoading,
  handlePostLink,
  isFetchLinkToken,
  linkStyle,
  linkTitle,
  shouldInvertLoaderColor,
  shouldAutoOpenLink,
}: IProps) => (
  <>
    {!linkToken && (
      <Button
        testId='plaidWrapperCTA'
        shouldInvertLoaderColor={shouldInvertLoaderColor}
        isLoading={isLoading || isFetchLinkToken}
        disable={isLoading || isFetchLinkToken}
        onClick={() => callbackHandler()}
        className={linkStyle}
        id=''
        title={linkTitle}
      />
    )}
    {linkToken && (
      <PlaidLink
        shouldAutoOpenLink={shouldAutoOpenLink}
        shouldInvertLoaderColor={shouldInvertLoaderColor}
        isLoading={isLoading || isFetchLinkToken}
        linkToken={linkToken}
        title={linkTitle}
        className={linkStyle}
        handlePostLink={handlePostLink}
      />
    )}
  </>
);
